import "./discrCardB.css";
import TestImage from "../logo/universe.png";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const services = [
  {
    title: "Individual Therapy",
    description:
      "In a comfortable and supportive atmosphere, you can confidentially talk about your full range emotions...",
  },
  {
    title: "Couples Therapy",
    description:
      "Relationships are one of the most difficult challenges we face as adults. Couples from different...",
  },
  {
    title: "Mindfulness Meditation",
    description:
      "In addition psychological counseling we also offer individual sessions and classes on mindfulness practices......",
  },
];

const DiscrCardB = () => {
  return (
    <section className="secondaryHomeDiscrCard">
      <div className="secondaryHomeDiscrCardHeader fx fx-ac fx-jb">
        <h2 className="fs8 fw600">Psychiatric Therapy Services</h2>

        <div className="secondaryHomeDiscrCardControls fx fx-ac space1">
          <button className="secondaryHomeDiscrCardBtn active">
            <ChevronLeftIcon />
          </button>

          <button className="secondaryHomeDiscrCardBtn">
            <ChevronRightIcon />
          </button>
        </div>
      </div>

      <div className="secondaryHomeDiscrCardGrid g g3 space2">
        {services.map((item, index) => (
          <div key={index} className="secondaryHomeDiscrCardItem fx-cl">
            <img
              src={TestImage}
              alt={item.title}
              className="secondaryHomeDiscrCardImage"
            />

            <div className="secondaryHomeDiscrCardContent fx-cl fx-ac space1">
              <h3 className="fs6 fw600">{item.title}</h3>

              <p className="fs4 lh3">{item.description}</p>

              <button className="secondaryHomeDiscrCardReadMore fx fx-ac fx-jc">
                Read More
                <ArrowForwardIcon sx={{ fontSize: "1.7rem" }} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DiscrCardB;
